const observer = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends observer {
  constructor(cb) {
    super((entries, obs) => {
      requestAnimationFrame(() => cb(entries, obs));
    });
  }
};

import React from "react";
import ReactDOM from "react-dom";

import App from "./App";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import * as serviceWorker from "./serviceWorker";

console.log("version --> 1.1.2");

const originalConsoleError = console.error;
console.error = (...args) => {
  if (args[0]?.includes?.("ResizeObserver loop")) return;
  originalConsoleError(...args);
};

const originalConsoleWarn = console.warn;
console.warn = (...args) => {
  if (args[0]?.includes?.("ResizeObserver loop")) return;
  originalConsoleWarn(...args);
};

if (window.__REACT_ERROR_OVERLAY_GLOBAL_HOOK__) {
  const origOnError = window.__REACT_ERROR_OVERLAY_GLOBAL_HOOK__.handleError;
  window.__REACT_ERROR_OVERLAY_GLOBAL_HOOK__.handleError = (error, ...args) => {
    if (error?.message?.includes("ResizeObserver loop")) return;
    origOnError.call(
      window.__REACT_ERROR_OVERLAY_GLOBAL_HOOK__,
      error,
      ...args,
    );
  };
}

ReactDOM.render(<App />, document.getElementById("root"));

serviceWorker.unregister();
